module.exports = __webpack_public_path__ + "static/img/icon_locate@2x.154e125a.png";